import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { ExtendedMeetingDashboardFragment } from '../ManagerMeetingsTable'

interface MeetingRescheduleButtonProps {
  meeting: ExtendedMeetingDashboardFragment
  onOpenModal: (meeting: ExtendedMeetingDashboardFragment) => void
  disabledTooltip?: string
}

export const MeetingRescheduleButton: FC<MeetingRescheduleButtonProps> = ({ meeting, onOpenModal, disabledTooltip }) => {
  const [t] = useTranslation()

  return (
    <>
      <PerButtonCircle
        onClick={(e) => {
          e.preventDefault()
          onOpenModal(meeting)
        }}
        color="secondary"
        icon="rescedule_fill"
        variant="pastel"
        disabled={!!disabledTooltip}
        tooltip={!!disabledTooltip ? disabledTooltip : t('meetingButtonActions.reschedule')}
        data-e2e-manager-meeting-action-button="reschedule"
      />
    </>
  )
}
